function generateNewStyleNumber() {
  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth() + 1;

  const arr = ["ANY"];
  for (let year = 2001; year <= currentYear; year++) {
    if (!(year === 2001)) {
      if (year < currentYear || (year === currentYear && currentMonth >= 3)) {
        arr.push(String(year % 100).padStart(2, "0"));
      }
    }

    // September → February (include from 2001 "51" onwards)
    if (year < currentYear || (year === currentYear && currentMonth >= 9)) {
      arr.push(String((year % 100) + 50).padStart(2, "0"));
    }
  }

  return arr;
}

const prefixStyleNumber = [
  "ANY",
  "1-9",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "30",
  "31",
  "33",
  "40",
  "44",
  "50",
  "55",
  "60",
  "66",
  "70",
  "77",
  "80",
  "88",
  "90",
  "99",
  "100",
  "111",
  "121",
  "123",
  "155",
  "200",
  "222",
  "300",
  "321",
  "333",
  "400",
  "444",
  "500",
  "555",
  "600",
  "666",
  "700",
  "777",
  "800",
  "888",
  "900",
  "999",
];

function getAlphas() {
  const alphabets = ["ANY"];
  for (let i = 65; i <= 90; i++) {
    alphabets.push(String.fromCharCode(i));
  }

  return alphabets;
}

export { generateNewStyleNumber, prefixStyleNumber, getAlphas };
